import { render, staticRenderFns } from "./WithdrawDialog.vue?vue&type=template&id=36eced97&scoped=true&"
import script from "./WithdrawDialog.vue?vue&type=script&lang=ts&"
export * from "./WithdrawDialog.vue?vue&type=script&lang=ts&"
import style0 from "./WithdrawDialog.vue?vue&type=style&index=0&id=36eced97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eced97",
  null
  
)

export default component.exports